import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  addStandardsAccessUser,
  getStandardsAccess,
  getStandardsAuthorities,
  removeStandardsAccessUser,
  setStandardsAuthorities,
  type StandardsAuthority,
} from '@/api/adminService'

const ACCESS_KEY = ['admin', 'standards-access'] as const
const AUTHORITIES_KEY = ['admin', 'standards-authorities'] as const

export function useStandardsAuthorities() {
  return useQuery({
    queryKey: AUTHORITIES_KEY,
    queryFn: getStandardsAuthorities,
  })
}

export function useStandardsAccess() {
  return useQuery({
    queryKey: ACCESS_KEY,
    queryFn: getStandardsAccess,
  })
}

export function useAddStandardsUser() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ authorityUuid, userId, email }: { authorityUuid: string; userId: string; email?: string | null }) =>
      addStandardsAccessUser(authorityUuid, userId, email),
    onSuccess: () => qc.invalidateQueries({ queryKey: ACCESS_KEY }),
  })
}

export function useRemoveStandardsUser() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ authorityUuid, userId }: { authorityUuid: string; userId: string }) =>
      removeStandardsAccessUser(authorityUuid, userId),
    onSuccess: () => qc.invalidateQueries({ queryKey: ACCESS_KEY }),
  })
}

export function useSetStandardsAuthorities() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (authorities: StandardsAuthority[]) => setStandardsAuthorities(authorities),
    onSuccess: () => qc.invalidateQueries({ queryKey: AUTHORITIES_KEY }),
  })
}
